import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Box, CardMedia, IconButton } from '@mui/material';
import { PlayArrow, VolumeOff, VolumeUp } from '@mui/icons-material';
import Colors from 'assets/style/Colors';
import { makeStyles } from '@mui/styles';
import MobileVideo from 'assets/videos/scriptio2.mp4';
import DesktopVideo from 'assets/videos/video2.mp4';
import "./style.css"

// const useStyle = makeStyles((theme) => ({
//     desktopVideo: {
//         [theme.breakpoints.down('md')]: {
//             display: 'none'
//         },
//         [theme.breakpoints.up('md')]: {
//             display: 'block'
//         },
//     },
//     mobileVideo: {
//         [theme.breakpoints.down('md')]: {
//             display: 'block'
//         },
//         [theme.breakpoints.up('md')]: {
//             display: 'none'
//         },
//     },
// }));

function Video() {
    // const classes = useStyle();
    const videoRef1 = useRef(null);
    const videoRef2 = useRef(null);

    const [isMuted, setIsMuted] = useState(true);
    const [isPlay, setIsPlay] = useState(true);

    const handleMute = () => {
        setIsMuted(!isMuted);
    };

    const handlePlay = () => {
        setIsPlay(!isPlay);
    };

    useEffect(() => {
        const handleAutoplay = (videoElement) => {
            videoElement.loop = false;
            videoElement.muted = true;
            videoElement.play().catch((error) => {
                console.error('Autoplay error:', error);
            });
        };

        if (videoRef1.current) {
            handleAutoplay(videoRef1.current);
        }
        if (videoRef2.current) {
            handleAutoplay(videoRef2.current);
        }

        return () => {
            if (videoRef1.current) {
                videoRef1.current.pause();
            }
            if (videoRef2.current) {
                videoRef2.current.pause();
            }
        };
    }, []);

    useEffect(() => {
        if (videoRef1.current) {
            videoRef1.current.muted = isMuted;
        }
        if (videoRef2.current) {
            videoRef2.current.muted = isMuted;
        }
    }, [isMuted]);

    useEffect(() => {
        if (isPlay) {
            if (videoRef1.current) {
                videoRef1.current.play().catch((error) => {
                    console.error('Play error:', error);
                });
            }
            if (videoRef2.current) {
                videoRef2.current.play().catch((error) => {
                    console.error('Play error:', error);
                });
            }
        } else {
            if (videoRef1.current) {
                videoRef1.current.pause();
            }
            if (videoRef2.current) {
                videoRef2.current.pause();
            }
        }
    }, [isPlay]);

    return (
        // <Box sx={{ position: 'relative' }}>
        //     <CardMedia
        //         sx={{ cursor: 'pointer', width: '100%', height: '100vh', position: 'relative' }}
        //         onClick={handlePlay}
        //     >
        //         {!isPlay && (
        //             <IconButton sx={{ zIndex: '25', cursor: 'pointer', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)' }}>
        //                 <PlayArrow sx={{ fontSize: '60px !important', color: Colors.white }} />
        //             </IconButton>
        //         )}
        //         <Box
        //             component={"video"}
        //             ref={videoRef1}
        //             src={DesktopVideo}
        //             playsInline
        //             // className={[classes.desktopVideo, "deskVideo"]}
        //             className={"deskVideo"}
        //             style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
        //             sx={{ display: { md: "block", xs: "none" } }}
        //         />
        //         <Box
        //             component={"video"}
        //             ref={videoRef2}
        //             src={MobileVideo}
        //             playsInline
        //             // className={[classes.mobileVideo, "mobVideo"]}
        //             className={"mobVideo"}
        //             style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
        //             sx={{ display: { md: "none", xs: "block" } }}
        //         />
        //     </CardMedia>
        //     {isMuted ? (
        //         <IconButton onClick={handleMute} sx={{ zIndex: '25', cursor: 'pointer', position: 'absolute', right: '25px', bottom: '15px' }}>
        //             <VolumeOff sx={{ color: Colors.white }} />
        //         </IconButton>
        //     ) : (
        //         <IconButton onClick={handleMute} sx={{ zIndex: '25', cursor: 'pointer', position: 'absolute', right: '25px', bottom: '15px' }}>
        //             <VolumeUp sx={{ color: Colors.white }} />
        //         </IconButton>
        //     )}
        // </Box>
        <Fragment>
            <Box
                sx={{
                    height: "100vh",
                    display: {
                        md: "block",
                        sm: "block",
                        xs: "none"
                    }
                }}
            >
                {/* <iframe width="100%" height="100%" src="https://www.youtube.com/embed/eA9Ph5dM04Q?si=5Nm7YmD7l1BEot-J" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                {/* <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Tl0VBY4Z_SM?si=yAfDkerLa7AuKpJu?autoplay=1&mute=1&loop=1&playlist=eA9Ph5dM04Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Tl0VBY4Z_SM?si=6L5g5Eqx--12sJrj&autoplay=1&mute=1&loop=1&playlist=Tl0VBY4Z_SM&rel=0" title="Scriptio" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </Box>
            <Box
                sx={{
                    height: "100vh",
                    display: {
                        md: "none",
                        sm: "none",
                        xs: "block"
                    }
                }}
            >
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Tl0VBY4Z_SM?si=6L5g5Eqx--12sJrj&autoplay=1&mute=1&loop=1&playlist=Tl0VBY4Z_SM&rel=0" title="Scriptio" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                {/* <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Tl0VBY4Z_SM?si=yAfDkerLa7AuKpJu?autoplay=1&mute=1&loop=1&playlist=9NdueOxCvsY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
            </Box>
        </Fragment>
    );
}

export default Video;

// import React, { useEffect, useRef, useState } from 'react';
// import { Box, CardMedia, IconButton } from '@mui/material';
// import { PlayArrow, VolumeOff, VolumeUp } from '@mui/icons-material';
// import Colors from 'assets/style/Colors';
// import { makeStyles } from '@mui/styles';
// import MobileVideo from '../../assets/videos/scriptio2.mp4';
// import DesktopVideo from '../../assets/videos/video2.mp4';

// const useStyle = makeStyles((theme) => ({
//     DesktopVideo: {
//         [theme.breakpoints.down('md')]: {
//             display: 'none'
//         },
//         [theme.breakpoints.up('md')]: {
//             display: 'block'
//         },
//     },
//     MobileVideo: {
//         [theme.breakpoints.down('md')]: {
//             display: 'block'
//         },
//         [theme.breakpoints.up('md')]: {
//             display: 'none'
//         },
//     },
// }));

// function Video() {
//     const classes = useStyle();
//     const videoRef1 = useRef(null);
//     const videoRef2 = useRef(null);

//     const [isMuted, setIsMuted] = useState(true);
//     const [isPlay, setIsPlay] = useState(true);
//     const [currentVideo, setCurrentVideo] = useState(null);

//     const handleMute = () => {
//         setIsMuted(!isMuted);
//     };

//     const handlePlay = () => {
//         setIsPlay(!isPlay);
//     };

//     useEffect(() => {
//         const handleAutoplay = (videoElement) => {
//             // videoElement.loop = true;
//             videoElement.muted = true;
//             videoElement.play().catch((error) => {
//                 console.error('Autoplay error:', error);
//             });
//         };

//         if (window.innerWidth >= 768) {
//             // Desktop video
//             setCurrentVideo(videoRef1);
//             handleAutoplay(videoRef1.current);
//         } else {
//             // Mobile video
//             setCurrentVideo(videoRef2);
//             handleAutoplay(videoRef2.current);
//         }

//         return () => {
//             if (currentVideo) {
//                 currentVideo.current.pause();
//             }
//         };
//     }, []);

//     useEffect(() => {
//         if (currentVideo) {
//             currentVideo.current.muted = isMuted;
//         }
//     }, [isMuted]);

//     useEffect(() => {
//         if (isPlay) {
//             if (currentVideo) {
//                 currentVideo.current.play().catch((error) => {
//                     console.error('Play error:', error);
//                 });
//             }
//         } else {
//             if (currentVideo) {
//                 currentVideo.current.pause();
//             }
//         }
//     }, [isPlay]);

//     return (
//         <Box sx={{ position: 'relative' }}>
//             <CardMedia
//                 sx={{ cursor: 'pointer', width: '100%', height: '100vh', position: 'relative' }}
//                 onClick={handlePlay}
//             >
//                 {!isPlay && (
//                     <IconButton sx={{ zIndex: '25', cursor: 'pointer', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)' }}>
//                         <PlayArrow sx={{ fontSize: '60px!important', color: Colors.white }} />
//                     </IconButton>
//                 )}
//                 <video
//                     ref={videoRef1}
//                     playsInline
//                     className={classes.DesktopVideo}
//                     style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
//                 >
//                     <source
//                         type="video/mp4"
//                         src={DesktopVideo}
//                     />
//                 </video>
//                 <video
//                     ref={videoRef2}
//                     playsInline
//                     className={classes.MobileVideo}
//                     style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
//                 >
//                     <source
//                         type="video/mp4"
//                         src={MobileVideo}
//                     />
//                 </video>
//             </CardMedia>
//             {isMuted ? (
//                 <IconButton onClick={handleMute} sx={{ zIndex: '25', cursor: 'pointer', position: 'absolute', right: '25px', bottom: '15px' }}>
//                     <VolumeOff sx={{ color: Colors.white }} />
//                 </IconButton>
//             ) : (
//                 <IconButton onClick={handleMute} sx={{ zIndex: '25', cursor: 'pointer', position: 'absolute', right: '25px', bottom: '15px' }}>
//                     <VolumeUp sx={{ color: Colors.white }} />
//                 </IconButton>
//             )}
//         </Box>
//     );
// }

// export default Video;

// import React, { useEffect, useRef, useState } from 'react';
// import { Box, CardMedia, IconButton } from '@mui/material';
// import { PlayArrow, VolumeOff, VolumeUp } from '@mui/icons-material';
// import Colors from 'assets/style/Colors';
// import { makeStyles } from '@mui/styles';
// import MobileVideo from '../../assets/videos/scriptio2.mp4';
// import DesktopVideo from '../../assets/videos/video2.mp4';

// const useStyle = makeStyles((theme) => ({
//     desktopVideo: {
//         [theme.breakpoints.down('md')]: {
//             display: 'none'
//         },
//         [theme.breakpoints.up('md')]: {
//             display: 'block'
//         },
//     },
//     mobileVideo: {
//         [theme.breakpoints.down('md')]: {
//             display: 'block'
//         },
//         [theme.breakpoints.up('md')]: {
//             display: 'none'
//         },
//     },
// }));

// function Video() {
//     const classes = useStyle();
//     const videoRef1 = useRef(null);
//     const videoRef2 = useRef(null);

//     const [isMuted, setIsMuted] = useState(true);
//     const [isPlay, setIsPlay] = useState(true);
//     const [currentVideo, setCurrentVideo] = useState(null);

//     const handleMute = () => {
//         setIsMuted(!isMuted);
//     };

//     const handlePlay = () => {
//         setIsPlay(!isPlay);
//     };

//     const handleResize = () => {
//         if (window.innerWidth >= 768) {
//             // Desktop video
//             setCurrentVideo(videoRef1);
//             videoRef2.current.pause();
//         } else {
//             // Mobile video
//             setCurrentVideo(videoRef2);
//             videoRef1.current.pause();
//         }
//     };

//     useEffect(() => {
//         handleResize();

//         const handleAutoplay = (videoElement) => {
//             videoElement.loop = false;
//             videoElement.muted = true;
//             videoElement.play().catch((error) => {
//                 console.error('Autoplay error:', error);
//             });
//         };

//         if (videoRef1.current && window.innerWidth >= 900) {
//             handleAutoplay(videoRef1.current);
//         }
//         if (videoRef2.current && window.innerWidth < 900) {
//             handleAutoplay(videoRef2.current);
//         }

//         window.addEventListener('resize', handleResize);

//         return () => {
//             if (videoRef1.current) {
//                 videoRef1.current.pause();
//             }
//             if (videoRef2.current) {
//                 videoRef2.current.pause();
//             }
//             window.removeEventListener('resize', handleResize);
//         };
//     }, [currentVideo]);

//     useEffect(() => {
//         if (currentVideo) {
//             currentVideo.current.muted = isMuted;
//         }
//     }, [isMuted, currentVideo]);

//     useEffect(() => {
//         if (isPlay) {
//             if (currentVideo) {
//                 currentVideo.current.play().catch((error) => {
//                     console.error('Play error:', error);
//                 });
//             }
//         } else {
//             if (currentVideo) {
//                 currentVideo.current.pause();
//             }
//         }
//     }, [isPlay, currentVideo]);

//     return (
//         <Box sx={{ position: 'relative' }}>
//             <CardMedia
//                 sx={{ cursor: 'pointer', width: '100%', height: '100vh', position: 'relative' }}
//                 onClick={handlePlay}
//             >
//                 {!isPlay && (
//                     <IconButton sx={{ zIndex: '25', cursor: 'pointer', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)' }}>
//                         <PlayArrow sx={{ fontSize: '60px!important', color: Colors.white }} />
//                     </IconButton>
//                 )}
//                 <video
//                     ref={videoRef1}
//                     playsInline
//                     className={classes.desktopVideo}
//                     style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
//                 >
//                     <source
//                         type="video/mp4"
//                         src={DesktopVideo}
//                     />
//                 </video>
//                 <video
//                     ref={videoRef2}
//                     playsInline
//                     className={classes.mobileVideo}
//                     style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
//                 >
//                     <source
//                         type="video/mp4"
//                         src={MobileVideo}
//                     />
//                 </video>
//             </CardMedia>
//             {isMuted ? (
//                 <IconButton onClick={handleMute} sx={{ zIndex: '25', cursor: 'pointer', position: 'absolute', right: '25px', bottom: '15px' }}>
//                     <VolumeOff sx={{ color: Colors.white }} />
//                 </IconButton>
//             ) : (
//                 <IconButton onClick={handleMute} sx={{ zIndex: '25', cursor: 'pointer', position: 'absolute', right: '25px', bottom: '15px' }}>
//                     <VolumeUp sx={{ color: Colors.white }} />
//                 </IconButton>
//             )}
//         </Box>
//     );
// }

// export default Video;
